import {IHoursOption} from "../types/IHoursOption";

export const getHoursOptions = (dayName: string, hoursData?: IHoursOption[], isToday?: boolean) => {
    const hoursRange = hoursData?.find((data) => data.dayName === dayName)?.range;
    const actualHour = new Date().getHours();

    if (hoursRange) {
        const upper = +hoursRange.upper.split(":")[0];
        const lower = +hoursRange.lower.split(":")[0];
        return Array.from({length: upper - lower}, (_, i) => {
            const hour = lower + i;
            const hourString = `${hour <= 9 ? `0${hour}` : hour}:00`;
            if (isToday && hour <= actualHour) {
                return null;
            }

            return {value: hourString, label: hourString};
        }).filter((option) => option !== null);
    }
    return [];
};
import {IHoursOption} from "../types/IHoursOption";

export const getHoursOptions = (dayName: string, hoursData?: IHoursOption[], isToday?: boolean) => {
    const hoursRange = hoursData?.find((data) => data.dayName === dayName)?.range;
    const actualHour = new Date().getHours();

    if (hoursRange) {
        const upper = +hoursRange.upper.split(":")[0];
        const lower = +hoursRange.lower.split(":")[0];
        return Array.from({length: upper - lower}, (_, i) => {
            const hour = lower + i;
            const hourString = `${hour <= 9 ? `0${hour}` : hour}:00`;
            if (isToday && hour <= actualHour) {
                return null;
            }

            return {value: hourString, label: hourString};
        }).filter((option) => option !== null);
    }
    return [];
};
